import Styles from './ConfirmApprovalsModal.module.scss'
import { Modal, useModals } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'

export const ConfirmApprovalsModal = ({ enabled, onConfirm }: { enabled: boolean; onConfirm: () => void }) => {
  const { closeModal } = useModals()

  const header = enabled ? 'Disable Approvals?' : 'Enable Approvals?'
  const content = enabled
    ? 'Autopilot will no longer require you to review and publish content before it is automatically posted.'
    : 'Autopilot will now require you to review and publish content before it is automatically posted.'
  const secondaryContent = enabled
    ? 'Your unpublished content will be set to Autoscheduled.'
    : 'Your Autoscheduled content will be set to Draft.'
  const buttonText = enabled ? 'Turn Off' : 'Turn On'

  return (
    <Modal.Root onPressOutside={closeModal}>
      <Modal.Header
        title={header}
        isConfirmation
        subHeader={
          <div className={Styles.confirmModalMessage}>
            <Text>{content}</Text>
            <Text>{secondaryContent}</Text>
          </div>
        }
      />
      <Modal.Footer isConfirmation>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton variant="secondary" onPress={closeModal}>
            Cancel
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton onPress={onConfirm}>{buttonText}</Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
